
<div class="container"> 
    <lib-logo></lib-logo>
    <!-- <lib-highlight-card [tourId]="'310'"></lib-highlight-card> -->
    <lib-audio-tours></lib-audio-tours>
    <lib-buffer [bufferHeight]="16"></lib-buffer>
    <lib-info-carousel></lib-info-carousel>
    <lib-buffer [bufferHeight]="16"></lib-buffer>
    <lib-exhibit-carousel></lib-exhibit-carousel>
    <lib-buffer [bufferHeight]="16"></lib-buffer>
    <lib-events></lib-events>
    <lib-buffer [bufferHeight]="16"></lib-buffer>
    <!-- <lib-collections></lib-collections> -->
    <!-- <lib-ar></lib-ar>  -->
    

    <lib-games-carousel></lib-games-carousel>
    <lib-buffer [bufferHeight]="16"></lib-buffer>

    <!-- <lib-events></lib-events> -->
    <!-- <lib-video-carousel></lib-video-carousel> -->
    <lib-action-group [buttonWidth]="'95vw'" [buttons]="buttons"></lib-action-group>
    <lib-buffer [bufferHeight]="100"></lib-buffer>
</div>